<template>
    <div class="page-header-block" :class="[scrollTop && scrollTop>0 && $route.path.indexOf('home') !==-1 ?'white-bg':'',channelWidth > 768 && $route.path.indexOf('home') ==-1?'not-home':'']">
        <el-row class="nav-row" type="flex" v-if="channelWidth > 768">
            <el-col :xs="1" :sm="2" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
                <div class="nav-logo">
                    <img class="logo-img" :class="[channelWidth <= 768? 'just-show':'']" :src="logoImg"/>
                    <img class="hidden-sm-and-down" :src="logoTextBlackImage" v-if="scrollTop && scrollTop>0 && $route.path.indexOf('home') !==-1">
                    <img class="hidden-sm-and-down" :src="logoTextImage" v-else>
                </div>
            </el-col>
            <el-col :xs="1" :sm="4" :md="4" :lg="7" :xl="7">&nbsp;</el-col>
            <el-col :xs="18" :sm="13" :md="13" :lg="7" :xl="7">
                <div class="nav-bar">
                    <div class="nav-link" :class="[$route.path.indexOf(item.pathName) !=-1 && channelWidth > 768  ? 'active':'',$route.path.indexOf('home') ==-1 || (scrollTop && scrollTop >0)? '':'home-page']"
                         v-for="(item,index) in routerList" @click="clickTab(index)">
<!--                        <el-popover trigger="hover" placement="bottom" :disabled="index !== 2 ">-->
                            <div slot="reference" @mouseenter ="enterFun(index)">{{ item.name }}</div>
<!--                            <div class="children-list" >-->
<!--                                <div class="list-item" v-for="(childrenItem,childrenIndex) in item.list" @click="jumpTo(index,childrenIndex)" :class="[$route.path.indexOf(item.list[childrenIndex].key) !==-1 ?'has-show':'']">{{childrenItem.name}}</div>-->
<!--                            </div>  -->
<!--                        </el-popover>-->
                    </div>
                    <transition name="children" v-on:enter="menuChange" v-on:leave="menuLeave">
                        <div class="children-tab" v-show="showChildren" @mouseleave="hiddenShow">
                            <div class="list-item" v-for="(childrenItem,childrenIndex) in routerList[2].list" @click="jumpTo(childrenIndex)" :class="[$route.path.indexOf(routerList[2].list[childrenIndex].key) !==-1 ?'has-show':'']">{{childrenItem.name}}</div>
                        </div>
                    </transition>

                </div>

            </el-col>
            <el-col :xs="1" :sm="2" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </el-row>
        <div class="phone-show" v-else>
            <div><img class="logo" :src="LogoPhoneImage" @click="jumpHome"/></div>
            <div>
                <img class="tab" :src="TabIcon" @click="showPhoneTab" v-show="!isPhoneTab"/>
                <img class="tab" :src="CloseTabIcon" @click="showPhoneTab" v-show="isPhoneTab"/>
            </div>
        </div>
        <div class="mark-bg" v-show="isPhoneTab" @click="showPhoneTab">
            <transition name="phone" v-on:enter="phoneMenuChange" v-on:leave="phoneMenuLeave" >
                <div class="tab-list"  v-show="isPhoneTab" :class="[childKey? childKey:'']">
                    <div class="list-item" v-for="(item,index) in routerList">
                        <div class="tab-bar" @click.stop="checkPhoneTab" :data-index="index" :data-key="item.pathName">
                            {{item.name}}
                            <img class="arrow" :class="[index == phoneCheckIndex?'rotate-img':'']" :src="ArrowIcon" v-if="index !== 0 && index !== 4" />
                        </div>
                        <transition name="check" v-on:enter="phoneTabChange" v-on:leave="phoneTabLeave" >
                            <div class="children" v-show="index !== 0 && index !== 4 && phoneCheckIndex == index">
                                <div class="children-list-item" v-for="(child,childIndex) in item.list" :class="[index==3?'cases-list':'']">
                                    <div v-if="index != 3" @click="phoneJump" :data-index="index" :data-child-index="childIndex" :data-key="childKey">{{child.name}}</div>
                                    <div v-if="index == 3" class="cases-item'" style="font-weight: bold">{{child.name}}</div>
                                    <div v-if="index == 3" v-for="(items,itemsIndex) in child.list" @click="phoneJump"
                                         :data-index="index" :data-child-index="childIndex" :data-items-index="itemsIndex" :data-key="childKey">
                                        {{items.name}}
                                    </div>
                                </div>

                            </div>
                        </transition>

                    </div>

                </div>
            </transition>

        </div>
    </div>
</template>

<script>
    import LogoImg from '../../views/image/logo_left.png'
    import LogoTextImage from '../../views/image/logo_right.png'
    import LogoTextBlackImage from '../../views/image/logo_right_black.png'
    import LogoPhoneImage from '../../views/image/common/logo_phone.png'
    import TabIcon from '../../views/image/common/tab_phone.png'
    import CloseTabIcon from '../../views/image/common/close_phone.png'
    import ArrowIcon from '../../views/image/common/right_arrow.png'
    import {mapActions} from 'vuex'
    export default {
        name: "page-header-block",
        data(){
            return{
                channelWidth: null,      //浏览器窗口宽度
                scrollTop:null,
                LogoPhoneImage:LogoPhoneImage,
                TabIcon:TabIcon,
                logoImg:LogoImg,
                ArrowIcon,
                logoTextImage:LogoTextImage,
                logoTextBlackImage:LogoTextBlackImage,
                CloseTabIcon:CloseTabIcon,
                routerList:[
                    {name:'首页',pathName:'home',path: '/home'},
                    {name:'产品介绍',pathName:'products',path:'/page/products',
                        list:[
                            {name:'网关系列',pathValue:'0'},
                            {name:'传感器系列',pathValue:'1'},
                            {name:'摄像头系列',pathValue:'2'},
                            {name:'设备监控中心',pathValue:'3'},
                        ]
                    },
                    {name:'解决方案',pathName:'solution',path: null,
                        list:[
                            {name:'校园解决方案',path:'/page/solution/school',key:'school'},
                            {name:'环保解决方案',path:'/page/solution/environment',key:'environment'},
                            {name:'城管解决方案',path:'/page/solution/administration',key:'administration'},
                            {name:'化工解决方案',path:'/page/solution/chemical-industry',key:'chemical-industry'},
                            {name:'工地解决方案',path:'/page/solution/construction',key:'construction'},
                            {name:'农业解决方案',path:'/page/solution/agriculture',key:'agriculture'}]},
                    {name:'成功案例',pathName:'cases',path: null,
                        list:[
                            {name:'电力',list:[{name:'无锡镇江电力物联网系统',value:'first'}]},
                            {name:'园区',list:[{name:'化工园区二道门智能化管理系统',value:'first'}]},
                            {name:'农业',list:[{name:'睢宁智慧农业物联网',value:'first'},{name:'青禾农场智慧化提升综合示范项目',value:'second'}]},
                            {name:'环保',list:[{name:'飞灰云智系统',value:'first'},{name:'飞灰填埋云智系统',value:'second'}]},
                            {name:'城管',list:[{name:'户外广告系统',value:'first'}]},
                            {name:'校园',list:[{name:'南京市同仁小学官网',value:'first'},{name:'学习者课堂评价系统',value:'second'}]},
                        ]},
                    {name:'关于我们',pathName:'about',path: '/page/about'}
                ],
                showChildren:false,     //判定是否展示解决子菜单
                showIndex:0,
                isPhoneTab:false,     //手机菜单tab
                phoneCheckIndex:-1,    //手机点击展示的下拉
                childKey:'',           //手机端tab子项列表类型
            }
        },
        watch:{
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                   this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        // console.log(this.channelWidth);
                        this.timer = false;
                    }, 400);
                }
            },

        },
        mounted(){

            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;
            // console.log(this.channelWidth);
            window.addEventListener('scroll',this.handleScroll)
        },
        methods:{
            ...mapActions([
                'changeSolutionBlockKey'
            ]),
            /**
             * 获取页面滚动
             */
            handleScroll(){
                let scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop;
                this.scrollTop = scrollTop;
            },
            /**
             *
             */
            enterFun(index){
                let that = this;
                console.log(index)
                if(index == 3){
                    this.$parent.changeShow(1);
                }else{
                    this.$parent.changeShow();
                }
                if(index == 2){
                    this.showChildren = true
                }else{
                    this.showChildren = false
                }
                console.log('this.showChildren',this.showChildren);
                this.showIndex = index
            },
            /**
             * 点击tab操作
             * @param index
             */
            clickTab(index){
                let list = this.routerList;
                if(!list[index].path){
                    if(index == 3){
                        this.$parent.changeShow(1);

                    }else{
                        this.$parent.changeShow();
                    }
                    console.log(index)
                }else{
                    this.$parent.changeShow();
                    this.$router.push(list[index].path);
                }
            },
            /**
             * 子项路由跳转
             * @param childIndex
             */
            jumpTo(childIndex){
                this.$parent.changeShow();
                let list = this.routerList[2].list;
                this.$router.push(list[childIndex].path);

                this.changeSolutionBlockKey(list[childIndex].key);
            },
            /**
             * 展示手机段菜单
             */
            showPhoneTab(){
                this.isPhoneTab = !this.isPhoneTab;
                if(!this.isPhoneTab){
                    this.childKey = '';
                    this.phoneCheckIndex = -1
                }
            },
            /**
             * 手机端获取点击的tab
             */
            checkPhoneTab(e){
                let key = e.currentTarget.dataset.key,
                    index = e.currentTarget.dataset.index;
                if(index == 0||index==4){
                    let list = this.routerList;
                    this.$router.push(list[index].path);
                    this.showPhoneTab()
                }else{
                    if(index == this.phoneCheckIndex){
                        this.phoneCheckIndex = -1;
                        this.childKey = '';
                    }else{
                        this.phoneCheckIndex = index;
                        this.childKey = key;
                    }
                    this.childKey = key;
                }


            },
            /**
             * 下拉动画触发
             * @param e
             * @param done
             */
            menuChange(e,done){
                e.offsetWidth;
                //下拉区域高度赋值
                e.style.maxHeight =  '300px';
                e.style.transition = "all .2s linear";
                done();
            },
            /**
             * 下拉动画结束
             * @param e
             */
            menuLeave(e){
                e.offsetWidth;
                e.style.maxHeight = 0;
                e.style.transition = "all .2s linear";
            },
            /**
             * 手机端下拉动画触发
             * @param e
             * @param done
             */
            phoneMenuChange(e,done){
                e.offsetWidth;
                //下拉区域高度赋值
                e.style.maxHeight =  '250px';
                e.style.transition = "all .4s linear";
                done();
            },
            phoneTabChange(e,done){
                e.offsetWidth;
                //下拉区域高度赋值
                let height = '';
                if(this.childKey === 'products'){
                    height = '160px'
                }else if(this.childKey === 'solution'){
                    height = '240px'
                }
                e.style.maxHeight =  height;
                e.style.transition = "all .2s linear";
                done();
            },
            /**
             * 手机端下拉动画结束
             * @param e
             */
            phoneMenuLeave(e){
                e.offsetWidth;
                e.style.maxHeight = 0;
                e.style.transition = "all .4s linear";
            },
            phoneTabLeave(e){
                e.offsetWidth;
                e.style.maxHeight = 0;
                e.style.transition = "all .2s linear";
            },
            /**
             * 隐藏菜单
             */
            hiddenShow(){
                this.showChildren = false
            },
            /**
             * 子项跳转
             * @param e
             */
            phoneJump(e){
                let key = e.currentTarget.dataset.key,
                    index = e.currentTarget.dataset.index,
                    childIndex = e.currentTarget.dataset.childIndex,
                    itemsIndex = e.currentTarget.dataset.itemsIndex,
                    list=[],
                    tabList = this.routerList;
                console.log(key)
                if(key === 'products'){
                    list = tabList[index].list;
                    this.$router.push({name:'products',params:{typeIndex:list[childIndex].pathValue}})
                }else if(key === 'solution'){
                    list = tabList[index].list;
                    this.$router.push(list[childIndex].path);
                }else if(key === 'cases'){
                    list = tabList[index].list[childIndex].list;
                    this.$router.push(`/page/cases?index=${childIndex}&id=${list[itemsIndex].value}`);
                }
            },
            /**
             * 跳转首页
             */
            jumpHome(){
                this.$router.push('/home')
            }
        }
    }
</script>

<style lang="scss" src="./index.scss" scoped>

</style>
<style lang="scss" src="./index-mini.scss" scoped>

</style>
